import { registerPlugin } from '@capacitor/core';
const WechatHK = registerPlugin('WechatHK', {
    web: () => import('./web').then(m => new m.WechatHKWeb()),
});
export * from './definitions';
export { WechatHK };
//# sourceMappingURL=index.js.map